<!-- eslint-disable -->
<template lang="pug">
    component.cs-button(
        :is="htmlTag"
        :type="type",
        @click="$emit('click', $event)",
        :disabled="disabled",
        :to="to",
        :class=`[
            'cs-button--size-' + size,
            pattern && color && 'cs-button--pattern-' + pattern + '-' + color,
            disabled && 'cs-button--disabled',
            fullWidth && 'cs-button--full-width',
            bold && 'cs-button--bold',
            narrow && 'cs-button--narrow'
        ]`,
    )
        .cs-button__icon(v-if="$slots['icon']")
            slot(name="icon" v-if="!loading")
        cs-loader.cs-button__loader(v-if="loading", type="button", size="base")
        slot(v-else)
</template>

<script>
    /*eslint-disable*/
    /**
     * CsButton are used to create clickable item.
     */
    export default {
        name: 'CsButton',
        status: 'ready',
        release: '1.0.0',
        props: {
            /**
             * The size of the button.
             * `small, base`
             */
            size: {
                type: String,
                default: 'base',
                validator: value => value.match(/(small|base)/)
            },
            /**
             * Pattern of the button.
             * `primary, primary-outline`
             */
            pattern: {
                type: String,
                default: 'primary',
                validator: value => value.match(/(primary|primary-outline)/)
            },
            /**
             * Color of the button.
             * `green, blue, orange, white`
             */
            color: {
                type: String,
                default: 'green',
                validator: value => value.match(/(green|blue|orange|white|user|gray)/)
            },
            /**
             * Type of the button.
             * `button, reset, submit`
             */
            type: {
                type: String,
                default: 'submit',
                validator: value => value.match(/(button|reset|submit)/)
            },
            /**
             * Type of the html tag.
             * `button, a`
             */
            htmlTag: {
                type: String,
                default: 'button',
                validator: value => value.match(/(button|a)/)
            },
            to: {
                type: Object
            },
            /**
             * Whether the button is disabled or not.
             */
            disabled: {
                type: Boolean,
                default: false
            },
            /**
             * Whether the button is full-width or not.
             */
            fullWidth: {
                type: Boolean,
                default: false
            },
            /**
             * Whether the button is loading or not.
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * Whether the button is bold or not.
             */
            bold: {
                type: Boolean,
                default: false
            },
            /**
             * Whether the button is narrow or not.
             */
            narrow: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .cs-button {
        box-sizing: border-box;

        padding: 15px 30px;

        transition: 0.3s;

        font-weight: normal;
        font-size: 16px;
        font-family: Rubik;
        line-height: 19px;

        border: none;
        border-radius: $border-radius-40;

        cursor: pointer;
        outline: none;
        appearance: none;

        display: inline-flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;
    }

    .cs-button__loader {
        width: 19px;
        height: 19px;
    }

    .cs-button__icon {
        display: flex;
        margin-right: 8px;
        height: 100%;
    }

    .cs-button--full-width {
        width: 100%;
    }

    .cs-button--bold {
        font-weight: 500;
    }

    .cs-button--pattern-primary-user {
        color: $x-color-white;
        background-color: var(--user-main-color);

        &:hover {
            background-color: var(--user-help-color);
        }
    }

    .cs-button--pattern-primary-blue {
        color: $x-color-white;
        background-color: $hsl-color-blue-56;

        &:hover {
            background-color: $hsl-color-blue-48;
        }
    }

    .cs-button--pattern-primary-green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;

        &:hover {
            background-color: $hsl-color-green-50;
        }

        a {
            text-decoration: none;
            color: $x-color-white !important;
        }
    }

    .cs-button--pattern-primary-orange {
        color: $x-color-white;
        background-color: $x-color-orange;

        &:hover {
            background-color: $hsl-color-orange-56;
        }
    }

    .cs-button--pattern-primary-white {
        color: $x-color-black;
        background-color: $x-color-white;

        &:hover {
            color: $x-color-black;
            background-color: $hsl-color-yellow-66;
        }
    }

    .cs-button--pattern-primary-outline-gray {
        color: $hsl-color-gray-52;
        border: 1px solid $hsl-color-gray-74;
        background-color: transparent;

        &:hover {
            color: $hsl-color-blue-56;
            border-color: $hsl-color-blue-56;
        }

        a {
            text-decoration: none;
            color: $hsl-color-gray-52 !important;
        }
    }

    .cs-button--pattern-primary-outline-green {
        color: $hsl-color-green-58;
        border: 1px solid $hsl-color-green-58;
        background-color: transparent;

        &:hover {
            color: $x-color-white;
            background-color: $hsl-color-green-50;
        }
    }

    .cs-button--pattern-primary-outline-blue {
        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;

        &:hover {
            color: $x-color-white;
            background-color: $hsl-color-blue-48;
        }
    }

    .cs-button--pattern-primary-outline-white {
        color: $x-color-white;
        background-color: transparent;
        border: 1px solid $x-color-white;

        &:hover {
            color: $x-color-black;
            background-color: $x-color-white;
        }
    }

    .cs-button--disabled {
        cursor: default;
        color: $hsl-color-gray-52;
        background: $hsl-color-gray-92;
        border-color: transparent;

        opacity: $opacity-disabled;
        pointer-events: none;
    }

    .cs-button--selector {
        background: $x-color-white;
        color: $hsl-color-gray-52;
        border: 1px solid $hsl-color-gray-52;
        border-collapse: collapse;
        border-radius: 0;
        box-sizing: border-box;
        flex: 1 1 0px;
        height: 100%;
        &:hover {
            color: $x-color-white;
            background: rgba($hsl-color-blue-56, $opacity-disabled);
            border: 1px solid rgba($hsl-color-blue-56, $opacity-disabled);
        }
    }

    .cs-button--selector:first-child {
        border-radius: 4px 0 0 4px;
    }

    .cs-button--selector:last-child {
        border-radius: 0 4px 4px 0;
    }

    .cs-button--active-selector {
        color: $x-color-white;
        background: $hsl-color-blue-56;
        border: 1px solid $hsl-color-blue-56;
        &:hover {
            color: $x-color-white;
            background: $hsl-color-blue-56;
            border: 1px solid $hsl-color-blue-56;
        }
    }

    .cs-button--narrow {
        border-radius: $border-radius-6;
        padding: 8px 16px;
        font-size: 14px;
        line-height: 17px;
    }
</style>
